const STORAGE_KEY = 'ut-ai-explorer-view';

export type AIExplorerViewMode = 'playground' | 'dashboards';

/** The last tab the user chose, defaulting to the Playground. Migrates the legacy grid/visual values. */
export function readViewMode(): AIExplorerViewMode {
    if (typeof window === 'undefined') return 'playground';
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === 'dashboards' || raw === 'visual') return 'dashboards';
    return 'playground';
}

export function writeViewMode(mode: AIExplorerViewMode): void {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, mode);
}
